module.exports = __webpack_public_path__ + "img/2.f7832253.png";